<template>
	<inertia-head title="Terms and Conditions" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Terms & Conditions</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content content-full mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<p>
					All membership plans automatically renew after the Free month/s promo
					included unless cancelled (Except cash and coupon payments).
				</p> 
				<p>Credit card payments will auto-renew and auto-debit after your subcription expires.</p>
				<p>
				I agree to the policy stipulated in this link
					<mark>
						<inertia-link :href="route('member.help.data-privacy-policy')">(www.trulyrichclub.com/data-privacy-policy)</inertia-link>
					</mark>
					and understand that the data collected from me are treated with
					strictest security and will be used in accordance to the creation of
					my membership profile in the Truly Rich Club as well as the sending of
					newsletters, updates and invites as part of my membership benefit.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
